import './Components';
import UserForm from "./UserForm.vue";

export default UserForm;